var React = require('react');
import { Link, browserHistory } from 'react-router';
var PropTypes = React.PropTypes;
var Auth = require("../../resources/auth");

import CircularProgress from 'material-ui/CircularProgress';

import ConceptMap from './ConceptMap';
// import ChartLabel from './chart-label';

// import RaisedButton from 'material-ui/RaisedButton';
import '../../css/components/Students/students.css';
import '../../css/components/StudentAnalytics/ViewStudentConceptMap.css';

// import { Pager } from 'react-bootstrap';

// import StudentsTable from './StudentsTable';
var StudentRes = require('../../resources/student');
var AnalyticsRes = require('../../resources/analytics');

const MATH_ID = 'a234e6f6-a3ee-4bfe-9143-5c52f89ac84c';
const SCIENCE_ID = '84c52703-3e79-4f8d-8376-d854093843c1';

const STUDENT_STATUSES = [{
  // title: 'Draft',
  // code: 'draft',
  // value: ['self'],
  // actions: ['edit', 'delete'],
  // count: '-',
  cols: ['firstName', 'lastName', 'email', 'phone', 'residentialAddress', 'schoolName', 'class', 'SA2Grade', 'parentName' ,'parentNo', 'parentEmail', 'lastActivityDate'],
  notes: [
    ''
  ]
}];

const ITEM_LIMIT = 20;

//FOR THE ANGULARJS CONCEPT MAP CHART COMPONENT TO WORK------------
const ENV_VAR = {"API_DOMAIN":"https://api-student.a-smartlearning.com","API_PUBLIC_DOMAIN":"https://lightning-api-en.herokuapp.com","API_SOCKET_DOMAIN":"https://lightning-api-socket.herokuapp.com","CLIENT_DOMAIN":"https://www.zenquiz.net/en","FACEBOOK_APP_ID":"762126443876627","FACEBOOK_FAN_PAGE":"https://www.facebook.com/zenquiz.net","GOOGLE_APP_ID":"970330798371-v4149a7euj93mihoi0qj9cegkgmikeok.apps.googleusercontent.com","TPL_SIGN":"f1b0ba324ca07a3ee84e290f6bf7f9d7","LOCALE":"en_US","TEAM_NAME":"ZenQuiz Team","SOURCE_NAME":"ZenQuiz","SMALL_LOGO":"https://cdn.zenquiz.net/static/Logos/Zenquiz+Original+Logo.png","HOME_PAGE":"https://www.zenquiz.net/en","SHARE_CAPTION":"Powered by ZenQuiz","RESOURCE_SIGN":"en_US_5ce70961916c7a3b3af24fb6657f61ca","API_MEDIA_DOMAIN":"https://media.zenquiz.net","ORGANIC_TOKEN":null};
const LANDING_DATA = {"MINIGAME":{},"QUIZ":{},"KQUIZ":{},"PQUIZ":{},"POLL":{},"LIST":{},"USERINFO":null};
const RESOURCES = {};

// import * from "/static/socket.io-1.3.3.js";
// import "/static/iframe_content.js";
// import "/static/notify.min.js";
// import "/static/jquery.shorten.1.0.js";
// import "/static/d3.js";
// import "/static/d3.layout.js";
// import "/static/Chart.min.js";

// //brower components
// import CryptoJS from "/static/crypto-js/crypto-js.js";
// import "/static/es5-shim/es5-shim.min.js";
// import "/static/json3/lib/json3.min.js";
// import "/static/intl-tel-input/build/js/utils.js";
// import "/static/moment/locale/en-gb.js";
// import "/static/isotope/jquery.isotope.min.js";
// import "/static/jcrop/js/jquery.Jcrop.min.js";

// //scripts
// import "/static/scripts/vendor.js";
// import "/static/scripts/scripts.js";
// import "/static/angular-chart.min.js";

//-----------------------------------------------------------------

var ViewStudentConceptMap = React.createClass({
  componentWillReceiveProps: function(nextProps) {
    this.setState({})
  },
  onSortChange: function(newSort) {
    // this.setState({
    //   sort: newSort,
    //   studentsData: [],
    //   isLoading: true,
    //   currentPager: 1,
    // }, () => {
    //   this.retrieveStudents();
    // });
  },
  getInitialState: function() {
    return {
        _id: '',
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        residentialAddress: '',
        schoolName: '',
        schoolClassName: '',
        SA2Grade: '',
        parentName: '',
        parentNo: '',
        parentEmail: '',
        lastActivityDate: '',
        statusMode: [],
        currentMode: {},
        isLoading: true,
        isGettingConcepts: true,
        concepts: {},
        allTimeStats:{},
        currentCourseInfo: {},
        courseID: MATH_ID,
        mathButtonStyle: "mistakesButton mbSelected",
        scienceButtonStyle: "mistakesButton",
      // conceptsMap: null,
    };
  },
  handleChangeData: function(e) {
    // var update = {};
    // update[field] = e.target.value;
    // this.setState(update);
    // var searchName = this.state.searchStudentName;
    // this.setState({
    //   searchStudentName: e.target.value,
    //   studentsData: [],
    //   isLoading: true,
    //   currentPager: 1,
    //   sort: 'firstName'
    // }, () => {
    //   this.retrieveStudents(this.state.searchStudentName,this.state.searchStudentName);
    // });
  },
  submit: function() {
    // var _this = this;
    // var oldPassword = _this.state.currentPassword;
    // var newPassword = _this.state.newPassword;
    // var confirmPassword = _this.state.confirmPassword;
    // if (!oldPassword || !newPassword || !confirmPassword) return alert('Please input all fields');
    // if (newPassword !== confirmPassword) return alert('New password not match');
    // _this.setState({
    //   isLoading: true
    // })
    // Auth.changePassword({
    //   "oldPassword": oldPassword,
    //   "newPassword": newPassword
    // }, function(err, res) {
    //   _this.setState({
    //     isLoading: false
    //   })
    //   if (err && err.response && err.response.text === 'WRONG_PASSWORD') return alert('Wrong password');
    //   if (err) return alert('Error occurred. Please try again later');
    //   alert('Change password success');
    // })
  },
  componentDidMount: function() {

    var _this = this;
    var statusMode = this.state.statusMode;
    statusMode = STUDENT_STATUSES;
    var currentUser = Auth.getCurrentUser();

    var currentURL = window.location.href;
    currentURL = currentURL.split("/");
    var studentID = currentURL[currentURL.length-1]; //get the current class ID
    
    // if (currentUser.status.indexOf('reviewer') >= 0) return browserHistory.push('/review-tasks');
    // if (currentUser.role === 'admin') {
    //   statusMode = ADMIN_STATUSES;
    // } else  {
    //   statusMode = TEACHER_STATUSES;
    // }
    var currentMode = statusMode[0];
    if (this.props.location.query.mode) {
      var mode = this.props.location.query.mode,
          mappedMode = statusMode.filter((value) => {
            return value.code === mode
          })[0];
      if (mappedMode) currentMode = mappedMode;
    }
    this.setState({
        _id: studentID,
        isLoading: true,
        statusMode: statusMode,
        currentMode: currentMode
    }, function() {
      // var count = statusMode.length;
      // for (var i = 0; i < statusMode.length; i++) {
      //   this.countCollectionInMode(statusMode[i], function() {
      //     count--;
      //     if (count <= 0) _this.forceUpdate();
      //   });
      // }
      this.retrieveStudent();
    });
  },
  retrieveStudent: function(fName,lName,callback) {
    callback = callback || function(){};
    var _this = this;
    var currentPager = this.state.currentPager;
    var options = {};
    options.skip = ITEM_LIMIT * (currentPager - 1);
    options.limit = ITEM_LIMIT;
    // options.sort = this.state.sort || "dateCreated";
    options.conditions = {};
    // options.conditions.status = {
    //   "$in": this.state.currentMode.value
    // }
    // if (!this.state.currentMode.canApplyAdminRole) {
    //   options.conditions.creator = Auth.getCurrentUser()._id;
    // }
    // if (this.state.currentMode.include) {
    //   options.include = this.state.currentMode.include;
    //   options.includeConditions = includeConditions[options.include];
    // }
          // console.log("state of mdoe is " + this.state.currentMode.cols);
    
    // var currentURL = window.location.href;
    // currentURL = currentURL.split("/");
    var studentID = this.state._id;//currentURL[currentURL.length-1]; //get the current class ID

    options.conditions.sort = this.state.sort || "firstName";
    // options.conditions.status = 'student';
    options.conditions.studentID = studentID;

    // var firstN = '';
    // var lastN = '';
    // if (fName) { firstN = fName; }
    // if (lName) { lastN = lName; }

    // options.conditions.sort = this.state.sort || "dateCreated";
    options.conditions.status = 'student';
    // options.conditions.firstName = firstN;
    // options.conditions.lastName = lastN;
    StudentRes.retrieveStudent(options, function(err, res) {
      // console.log("BEFORE DON sdfdsfsE!!");
      // if (callback) return callback(err, res);

      console.log("RES IS :" + res.lastName);


        _this.setState({
            _id: studentID,
            isLoading: false,
            firstName: res.firstName,
            lastName: res.lastName + "'s Concept Map",
            email: res.email,
            phone: res.phone,
            residentialAddress: res.metadata.residentialAddress,
            schoolName: res.metadata.school,
            schoolClassName: res.metadata.class,
            SA2Grade: res.metadata.SA2Grade,
            parentName: res.metadata.parentName,
            parentNo: res.metadata.parentNo,
            parentEmail: res.metadata.parentEmail,
            lastActivityDate: '',
            // studentsData: (!err && res) ? res: [{}]
            }, () => {

              //TODO: now retrieve the concepts (math/science for this student)
              _this.retrieveConcepts();
              // _this.retrieveStudentAllTimeStats();
                // var sData = _this.state.studentsData;
                // for (var i = 0; i < sData.length; i++) {

                //     var thisData = sData[i];
                //     var dDate = thisData['lastActivityDate'];
                //     var processDate = new Date(dDate);
                //     var dateToDisplay = processDate.toDateString();
                //     if (processDate.getFullYear()=='1970') { dateToDisplay = '-';}
                //     thisData['lastActivityDate'] = dateToDisplay;//processDate.getFullYear() + "/" + processDate.getMonth() + "/" + processDate.getDate();
                // }

                // _this.setState({
                //     studentsData: sData
                // });
            // console.log("DONE!!!");
            }
        );
    })
  },
  retrieveConcepts: function(callback) {

    callback = callback || function(){};
    var _this = this;
    var currentPager = this.state.currentPager;
    var options = {};
    options.skip = ITEM_LIMIT * (currentPager - 1);
    options.limit = ITEM_LIMIT;
    options.tree = true;
    options.max_level = 4;
    options.root = _this.state.courseID;
    // options.sort = this.state.sort || "dateCreated";
    options.conditions = {};

    AnalyticsRes.retrieveStudentConceptMap(options, function(err, res) {

      

      // console.log("CONCEPT MAP DATA IS NOW: ",conceptMapData);
      _this.setState({
        concepts: res, //res,
        // isGettingConcepts: false
      }, ()=> {
        // console.log("res is: ",res);
        _this.retrieveStudentAllTimeStats();
      });
    });
  },

  retrieveStudentAllTimeStats: function(callback) {

    callback = callback || function(){};
    var _this = this;
    var currentPager = this.state.currentPager;
    var options = {};

    options.concept_config = {};
    options.concept_config.root = _this.state.courseID;//_this.state.courseID;//"a234e6f6-a3ee-4bfe-9143-5c52f89ac84c"; //_id of "maths" in concepts table
    options.concept_config.leaf = true;
    options.concept_config.max_level = 4;

    options.conditions = {};

    var studentID = this.state._id;//currentURL[currentURL.length-1]; //get the current class ID

    // options.conditions.status = 'student';
    options.skip = 0;
    options.conditions.user = studentID;
    options.conditions.type = "USER_CONCEPT_PRACTICE";

    AnalyticsRes.retrieveStudentAllTimeStats(options, function(err, res) {
      
      _this.setState({

        allTimeStats: res
        // isGettingConcepts: false
      }, ()=> {
        
        _this.retrieveStudentCurrentCourse();
      });
      // _this.setState({
      //   isGettingConcepts: false
      // });
    });
  },

  retrieveStudentCurrentCourse: function(callback) {

    callback = callback || function(){};
    var _this = this;
    var currentPager = this.state.currentPager;
    var options = {};

    // options.concept_config = {};
    // options.concept_config.root = MATH_ID;//_this.state.courseID;//"a234e6f6-a3ee-4bfe-9143-5c52f89ac84c"; //_id of "maths" in concepts table
    // options.concept_config.leaf = true;
    // options.concept_config.max_level = 4;

    options.include = "item";
    options.conditions0 = {};

    var studentID = this.state._id;//currentURL[currentURL.length-1]; //get the current class ID

    // options.conditions.status = 'student';
    options.skip = 0;
    options.conditions0.user = studentID;
    options.conditions0.type = "COURSE_REGISTRATION";

    var conceptsGotten = _this.state.concepts;

    const STYLES = {
      mainTitle: {
        fontSize:24,
        // position:"absolute",
        // top:"1",
        textAlign:"center"
        // float:"top",
        // textAnchor:"top",
        // anchor:"top",
        // paddingTop:120,
        // paddingBottom:400,
        // cx:"0",
        // cy:"10em"
      },
      conceptTitle: {
        fontSize:18,
        textAlign:"center",
        color:"black",
        paddingLeft:80,
        paddingRight:80,
        paddingTop:-200
        // textAlign:"center",
        // textAnchor:"top",
        // anchor:"top"
        // paddingInner:16
      },
      innerConceptTitle: {
        color:"black",
        textAlign:"center",
        // zIndex:99999
      },
      innestConceptTitle: {
        color:"black",
        textAlign:"center",
        paddingTop:20,
        // zIndex:99998
      }
    }
    // var allTimeStats = _this.state.allTimeStats; //get the all time stats so can get the mastery score for each concept (so can color the circles correctly)

    AnalyticsRes.retrieveStudentCurrentCourses(options, function(err, res) {

// console.log("CONCEPT MAP DATA IS NOW: ",conceptsGotten);

      var currentCourses = res[0]; //default to current courses for Math

      var conceptMapData = {};
      var circleSizeContainer = 1000;//633280;
      var circleSizeBiggest = 86656;
      var circleSizeMedium = 43328;//21664;
      var circleSizeSmallest = 5416;

      var title = "Math";
      if (_this.state.courseID === SCIENCE_ID) { 

        title="Science"; 
        currentCourses = res[1]; //get current courses for science
      }

      //get the current concept from current courses
      var currentConceptID = currentCourses.items[0].metadata.currentConcept;
      var currentConceptColor = "#6495ed";
      console.log("CURRENT CONCEPT ID IS ",currentConceptID);

      conceptMapData.title = title;
      conceptMapData.conceptName = title;
      conceptMapData.color = "#7ecdc5";
      conceptMapData.size = circleSizeContainer;
      conceptMapData.style = STYLES["mainTitle"];
      conceptMapData.level = 0;
      conceptMapData.children = [];

      var color = "#d0ecea";//"#12939A";
      
      var conceptLength = conceptsGotten.children.length;//res.children.length;
      for (var i = 0; i < conceptLength; i++) {

        var eachChildren = conceptsGotten.children[i];//res.children[i];

        //getting the title for this parent concept (e.g Numbers)
        var newChildren = {};
        newChildren.title = eachChildren.title;
        newChildren.conceptName = eachChildren.title;
        newChildren._id = eachChildren._id;

        var thisSize = circleSizeContainer/conceptLength;
        newChildren.size = thisSize;//circleSizeBiggest;
        // newChildren.padding = 12;
        
        //if is current concept
        if (newChildren._id === currentConceptID) { newChildren.color = currentConceptColor; }
        else { newChildren.color = "#4dc3ca"; } //if is not current concept

        newChildren.style = STYLES["conceptTitle"];
        newChildren.level = 1;
        // newChildren.cx = "0";
        // newChildren.cy = "10em";

        // conceptMapData.children[i] = {};
        // conceptMapData.children[i].title = eachChildren.title;
        newChildren.children = [];
        // conceptMapData.children[i].children = {}; //creating an array for the children concepts of this parent concept

        var childLength = eachChildren.children.length;
        for (var x = 0; x < childLength; x++) {

          var eachChildConcept = eachChildren.children[x]; //get the 2nd deepest children concepts
          // console.log("CHILD CONCEPT IS: ",eachChildConcept.title);
          
          var newInnerChildren = {};

          newInnerChildren.title = eachChildConcept.title;

          newInnerChildren.conceptName = eachChildConcept.title;
          newInnerChildren._id = eachChildConcept._id;
          newInnerChildren.level = 2;

          // newInnerChildren.x = 0;
          // newInnerChildren.y = 0;

          var innerSize = thisSize/childLength;
          newInnerChildren.size = innerSize;//circleSizeMedium;

          var finalChildLength = eachChildConcept.children.length; //check to see if have any more children to add

          //if is current concept
          if (newInnerChildren._id === currentConceptID) { 

            newInnerChildren.color = currentConceptColor; 

            if (finalChildLength <= 0) { newInnerChildren.style = STYLES["innestConceptTitle"]; }
            else { newInnerChildren.style = STYLES["innerConceptTitle"]; }

          }
          else { //if not current concept

            if (finalChildLength <= 0) { 

              newInnerChildren.style = STYLES["innestConceptTitle"];
              newInnerChildren.color = _this.getColorForConcept(eachChildConcept._id,eachChildConcept.metadata,eachChildConcept.status); 

            } //if no more, use white as the color for this circle
            else { //if still have, use a darker blue as the color for this circle
              newInnerChildren.style = STYLES["innerConceptTitle"];
              newInnerChildren.color = "#30afca"; 
            } 
          }

          //color;
          newInnerChildren.children = [];
          
          // conceptMapData.children[i].children.title = eachChildConcept.title;
          // conceptMapData.children[i].children.children = {};

          for (var m = 0; m < finalChildLength; m++) {

            var smallestChildConcept = eachChildConcept.children[m]; //get the smallest/deepest children concepts
            
            var newInnestChildren = {};
            //getting the title for this smallest child concept (e.g Multiples)

            newInnestChildren.title = "";//smallestChildConcept.title;
            newInnestChildren.conceptName = smallestChildConcept.title;
            newInnestChildren._id = smallestChildConcept._id;

            var innestSize = innerSize/finalChildLength;
            newInnestChildren.size = innestSize;//circleSizeSmallest;

            if (newInnestChildren._id === currentConceptID) { newInnestChildren.color = currentConceptColor; } //if is current concept
            else { //if not current concept, get the color based on the mastery level score
              newInnestChildren.color = _this.getColorForConcept(smallestChildConcept._id,smallestChildConcept.metadata,smallestChildConcept.status); //color;
            }
            newInnestChildren.style = STYLES["innestConceptTitle"];
            newInnestChildren.level = 3;

            // conceptMapData.children[i].children.children.title = smallestChildConcept.title;
            // conceptMapData.children[i].children[x].children.title = smallestChildConcept.title;
            newInnerChildren.children.push(newInnestChildren);
          }

          newChildren.children.push(newInnerChildren);
          // conceptMapData.children[i]
        }

        conceptMapData.children.push(newChildren);
      }  

      console.log("CONCEPT MAP DATA IS ", conceptMapData);

      _this.setState({

        concepts: conceptMapData,
        currentCourseInfo: res,
        isGettingConcepts: false

      }, () => {

        // _this.retrieveMathConcepts();
      });
    });
  },

  getColorForConcept: function(conceptID,metadata,status) {

    var _this = this;
    var allTimeStats = _this.state.allTimeStats;

    //colors for the various mastery level for each concept
    var masteryNormalColor = "#d0ecea";//"#30afca"; //white
    var masterySpecialColor = "#f4511e"; //red
    var masteryNeedImprovementColor = "#ffca28"; //yellow
    var masteryGoodColor = "#00e676"; //green
    var masteryLockedColor = "#a0afae";

    if (status=="public") {

      if (metadata.LSQuestionCount == 0 && metadata.SSMCQQuestionCount == 0 && metadata.kquestionCount == 0) {
        return masteryLockedColor;
      }

    } else if (status=="limited") { return masteryLockedColor; }
    

    //get how many all time stats there are
    var allTimeCount = allTimeStats.length;
        // console.log("SEARCHING CONCEPT ID IS ",conceptID);

    var ifFoundConcept = false;
    for (var x = 0; x < allTimeCount; x++) {

      var thisStat = allTimeStats[x]; 
      if (thisStat.concept === conceptID) {

        ifFoundConcept = true;
        // console.log("FOUND THIS STAT CONCEPT IS ",thisStat.concept);
        // console.log("FOUND CONCEPT ID IS ",conceptID);

        if (thisStat.totalAttemptCount == 0 && thisStat.totalAnswerCount == 0) {
          return masteryNormalColor;
        } else if (thisStat.totalAnswerCount == 0 && thisStat.masteryScore == 0) {
          return masteryNormalColor;
        } 
        else {
          if (thisStat.masteryScore >= 0.75) { return masteryGoodColor; }
          else if (thisStat.masteryScore > 0.5) { return masteryNeedImprovementColor; } //0.6
          else if (thisStat.masteryScore >= 0) { return masterySpecialColor; }
        }
        // else { return masteryNormalColor; }
      }
    }

    // if (!ifFoundConcept) {
    //   return masteryLockedColor;
    // }

    return masteryNormalColor;
  },

  navigatePager: function(dir) {
    var currentPager = this.state.currentPager,
              _this  =  this;
    currentPager += dir;
    _this.setState({
      currentPager: currentPager,
      isLoading: true
    }, function() {
      this.retrieveStudents(this.state.searchStudentName,this.state.searchStudentName);
      // this.retrieveStudents(function(err, res) {
      // })
    })
  },

  showMath: function(_id) {

    var _this = this;
    _this.setState({
        mathButtonStyle: "mistakesButton mbSelected",
        scienceButtonStyle: "mistakesButton",
        courseID: MATH_ID,
        isGettingConcepts: true
    }, () => {
      _this.retrieveConcepts();
    });
  },
  showScience: function(_id) {

    var _this = this;
    _this.setState({
        mathButtonStyle: "mistakesButton",
        scienceButtonStyle: "mistakesButton mbSelected",
        courseID: SCIENCE_ID,
        isGettingConcepts: true
    }, () => {
      _this.retrieveConcepts();
    });
  },

  renderConceptMap: function() {

    var _this = this;

    return (
      <div className="concept-table">
        
        <div className="concept-map">
          <ConceptMap treeMapData={_this.state.concepts} />
        </div>
      
        <div className="concept-detail">
          <div className="detail-info"></div>
          <div className="detail-instruction">
            <div className="sign choosing"><div className="imgIcon"></div>Concept you are choosing
              
            </div>
            <div className="sign current"><div className="imgIcon"></div>Your current concept
              
            </div>
            <div className="sign master-3"><div className="imgIcon"></div>Concept with <b>Excellent/Good</b> Mastery Level
              
            </div>
            <div className="sign master-2"><div className="imgIcon"></div>Concept with <b>Need improvement</b> Mastery Level
              
            </div>
            <div className="sign master-1"><div className="imgIcon"></div>Concept with <b>Need special attention</b> Mastery Level
              
            </div>
          </div>
        </div>
        
      </div>
    );
  },

  render: function() {
    var _this = this;
    return (
        <div className="conceptMap">
            <div className="row createStudentRow">
                <div className="col col-md-2 DivlblCreateStudent">
                    <label className="lblCreateStudent"></label>
                </div>
                <div className="col col-md-10 DivTxtCreateStudent">
                    <label className="lblStudentInfo"><h3> {_this.state.firstName} {_this.state.lastName} </h3></label>
                </div>
            </div>
            <hr/>
            <div className="dp-inline-block">
              <button
                  value="Math"
                  onClick={this.showMath.bind(this,_this.state._id)}
                  className={_this.state.mathButtonStyle}
              >Math</button>
            </div>
            <div className="dp-inline-block">
                <button
                    value="Science"
                    onClick={this.showScience.bind(this,_this.state._id)}
                    className={_this.state.scienceButtonStyle}
                >Science</button>
            </div>
            {
              _this.state.isGettingConcepts &&
              <CircularProgress />
            }
            { 
              (!_this.state.isGettingConcepts) &&
              
                  _this.renderConceptMap()
                
                
              
            }
            <script src="static/socket.io-1.3.3.js" charset="utf-8"></script>
            <script src="static/iframe_content.js"></script>
            <script src="static/crypto-js/crypto-js.js"></script>

            <script src="static/es5-shim/es5-shim.min.js"></script>
            <script src="static/json3/lib/json3.min.js"></script>

            <script src="static/Chart.min.js"></script>

            <script src="static/scripts/vendor.js"></script>

            {/*<script type="text/javascript" src="static/intl-tel-input/build/js/utils.js"></script>*/}
            <script type="text/javascript" src="static/moment/locale/en-gb.js"></script>
            <script src="static/notify.min.js"></script>
            <script src="static/jquery.shorten.1.0.js"></script>
            <script src="static/d3.js"></script>
            <script src="static/d3.layout.js"></script>

            <script src="static/angular-chart.min.js"></script>

            <script src="static/scripts/scripts.js"></script>

            <script type="text/javascript" src="static/isotope/jquery.isotope.min.js"></script>
            <script src="static/jcrop/js/jquery.Jcrop.min.js"></script>
            
            {/*{pageinit.init()}*/}

        </div>
        
        
        
        

        // <div className="students">
            
        // <div className="row createStudentRow">
        //     <div className="col col-md-2 DivlblCreateStudent">
        //         <label className="lblCreateStudent"></label>
        //     </div>
        //     <div className="col col-md-10 DivTxtCreateStudent">
        //         <label className="lblStudentInfo"><h3> {_this.state.firstName} {_this.state.lastName} </h3></label>
        //     </div>
        // </div>
        // <hr/>
        //     <div className="row createStudentRow">
        //         <div className="col col-md-2 DivlblCreateStudent">
        //             <label className="lblCreateStudent">Email</label>
        //         </div>
        //         <div className="col col-md-10 DivTxtCreateStudent">
        //             <label className="lblStudentInfo">{_this.state.email}</label>
        //         </div>
        //     </div>
        //     <br/>
        //     <div className="row">
        //         <div className="col col-md-2 DivlblCreateStudent">
        //         <label className="lblCreateStudent">Mobile Number</label>
        //         </div>
        //         <div className="col col-md-10 DivTxtCreateStudent">
        //             <label className="lblStudentInfo">{_this.state.phone}</label>
        //         </div>
        //     </div>
        //     <br/>
        //     <div className="row">
        //         <div className="col col-md-2 DivlblCreateStudent">
        //         <label className="lblCreateStudent">Residential Address</label>
        //         </div>
        //         <div className="col col-md-10 DivTxtCreateStudent">
        //             <label className="lblStudentInfo">{_this.state.residentialAddress}</label>
        //         </div>
        //     </div>
        //     <br/>
        //     <div className="row">
        //         <div className="col col-md-2 DivlblCreateStudent">
        //         <label className="lblCreateStudent">School Name</label>
        //         </div>
        //         <div className="col col-md-10 DivTxtCreateStudent">
        //             <label className="lblStudentInfo">{_this.state.schoolName}</label>
        //         </div>
        //     </div>
        //     <br/>
        //     <div className="row">
        //         <div className="col col-md-2 DivlblCreateStudent">
        //         <label className="lblCreateStudent">Class</label>
        //         </div>
        //         <div className="col col-md-10 DivTxtCreateStudent">
        //             <label className="lblStudentInfo">{_this.state.schoolClassName}</label>
        //         </div>
        //     </div>
        //     <br/>
        //     <div className="row">
        //         <div className="col col-md-2 DivlblCreateStudent">
        //         <label className="lblCreateStudent">Latest SA1/2 Grade</label>
        //         </div>
        //         <div className="col col-md-10 DivTxtCreateStudent">
        //             <label className="lblStudentInfo">{_this.state.SA2Grade}</label>
        //         </div>
        //     </div>
        //     <br/>
        //     <div className="row">
        //         <div className="col col-md-2 DivlblCreateStudent">
        //         <label className="lblCreateStudent">Parent's Name</label>
        //         </div>
        //         <div className="col col-md-10 DivTxtCreateStudent">
        //             <label className="lblStudentInfo">{_this.state.parentName}</label>
        //         </div>
        //     </div>
        //     <br/>
        //     <div className="row">
        //         <div className="col col-md-2 DivlblCreateStudent">
        //         <label className="lblCreateStudent">Parent's Telephone</label>
        //         </div>
        //         <div className="col col-md-10 DivTxtCreateStudent">
        //             <label className="lblStudentInfo">{_this.state.parentNo}</label>
        //         </div>
        //     </div>
        //     <br/>
        //     <div className="row">
        //         <div className="col col-md-2 DivlblCreateStudent">
        //         <label className="lblCreateStudent">Parent's Email</label>
        //         </div>
        //         <div className="col col-md-10 DivTxtCreateStudent">
        //             <label className="lblStudentInfo">{_this.state.parentEmail}</label>
        //         </div>
        //     </div>
        //     <br/><br/>
        // </div>
    );
  }

});

module.exports = ViewStudentConceptMap;



/** WEBPACK FOOTER **
 ** ./src/components/StudentAnalytics/ViewStudentConceptMap.js
 **/